
import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SettingService } from "./setting.service";
import { ApiControllerService } from "./api-controller.service";

export interface ISimpleEmail {
  From?: string;
  Subject?: string;
  Email?: string;
  Content?: string;
}

@Injectable({
    providedIn: 'root'
  })
export class EmailService
{
  constructor(protected http: HttpClient,
    private setting: SettingService,
    private apiController: ApiControllerService) {

  }

  send(model: ISimpleEmail) : Observable<boolean> {
    return Observable.create(o => {
        /* this.http.post(this.setting.apiUrl('/customerEmail/sendSimpleEmail'), model)
           .subscribe(
            (data: any) => {
              o.next(data);
              o.complete();
            }, 
            (error) => {
              o.next(false);
              o.complete();
           }); */
          this.apiController.post(this.setting.apiUrl('/customerEmail/sendSimpleEmail'), model)
           .subscribe(
            (data: any) => {
              o.next(data);
              o.complete();
            }, 
            (error) => {
              o.next(false);
              o.complete();
           });
    });    
  }

}
